// Copyright (c) 2016 Deere & Company

import ProductRegistration from './product-registration';
import actionCreators from '../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.productRegistration,
    measurementReadings: state.latestPerUnitMeasurements
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ProductRegistration);



// WEBPACK FOOTER //
// ./src/product/product-registration/components/index.js